<template>
	<div>
		<h1 class="p-text-bold p-my-0">Step 3: Waivers & Permissions</h1>

		<div
			v-for="childNumber in store.ProgramSelection.numOfChildren"
			:key="childNumber"
			class="p-mt-4"
		>
			<ChildWaiver
				:childNumber="childNumber"
				:validateForm="validateForm"
				:validateAllChildrenInfoForms="validateAllChildrenInfoForms"
			/>
		</div>

		<div class="p-d-flex p-jc-between p-mt-3 p-no-gutters">
			<div class="p-mb-3 p-col-6 p-pl-0">
				<Button
					label="Back"
					icon="pi pi-angle-left"
					class="p-button-secondary"
					style="min-width: 120px; max-width: 120px"
					@click="prevStep"
				/>
			</div>

			<div class="p-mb-3 p-col-6 p-pr-0">
				<Button
					label="Next"
					icon="pi pi-angle-right"
					iconPos="right"
					style="min-width: 120px; max-width: 120px"
					@click="nextStep"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import { useFormDataStore } from "../../store/formData.js";
import ChildWaiver from "../blocks/ChildWaiver.vue";
import { useVuelidate } from "@vuelidate/core";

export default {
	name: "Waiver",
	components: {
		ChildWaiver,
	},
	data() {
		return {
			validateForm: 0,
			submitted: false,
			allChildrenFormStates: [{}],
		};
	},
	setup() {
		const store = useFormDataStore();

		return {
			store,
			v$: useVuelidate(),
		};
	},
	props: {
		loadDonationParams: {
			type: Object,
		},
	},
	methods: {
		nextStep() {
			this.validateForm += 1;
			for (const child in this.store.ChildInfo) {
				this.allChildrenFormStates[child.childNumber] = false;
			}
		},
		prevStep() {
			this.$emit("prevStep");
		},
		validateAllChildrenInfoForms(validChildInfoForm, childNumber) {
			this.allChildrenFormStates[childNumber] = validChildInfoForm;
			let validStates = Object.values(this.allChildrenFormStates);
			let allFormsValid = true;
			for (let i = 0; i <= this.store.ProgramSelection.numOfChildren; i++) {
				if (validStates[i] === false) {
					allFormsValid = false;
				}
			}

			if (allFormsValid) {
				this.store.Waivers = {
					waiversDone: true,
				};
				this.$nextTick(() => {
					this.$emit("nextStep");
				});
			} else {
				this.scrollToFirstError();
			}
		},
		scrollToFirstError() {
			this.$nextTick(() => {
				if (document.querySelector(".p-error")) {
					let domRect = document
						.querySelector(".p-error")
						.getBoundingClientRect();

					window.scrollTo({
						left: domRect.left + document.documentElement.scrollLeft,
						top: domRect.top + document.documentElement.scrollTop - 100,
						behavior: "smooth",
					});
				}
			});
		},
	},
};
</script>

<style lang="scss" scoped></style>
